import { Route, Routes, Navigate } from 'react-router-dom'
import IndexPage from './pages/IndexPage'
import ExplorePage from './pages/ExplorePage'
import ConfigPage from './pages/ConfigPage'
import ViewPage from './pages/ViewPage'
import LaunchPage from './pages/LaunchPage'

export default function App() {
  // Use simple mode if VITE_SIMPLE_MODE is set or we're running locally without complex backend
  const useSimpleMode = import.meta.env.VITE_SIMPLE_MODE === 'true' || 
                       (!import.meta.env.VITE_BACKEND_URL && window.location.hostname === 'localhost')
  
  return (
    <Routes>
      <Route path="/" element={<IndexPage />} />
      <Route path="/explore" element={<ExplorePage />} />
      <Route path="/config" element={<ConfigPage />} />
      <Route path="/view" element={<ViewPage />} />
      <Route path="/launch" element={<LaunchPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}


